module.exports = __webpack_public_path__ + "static/media/the-athlete-beat.21e31531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customer-logos/the-athlete-beat.png
// module id = 165
// module chunks = 0